import Swiper from 'swiper/bundle'

window.customElements.define('hero-full-banner', class HeroFullBanner extends HTMLElement {
  constructor() {
    super()

    const autoScroll = this.dataset.autoScroll === 'true'
    const autoScrollSpeed = parseInt(this.dataset.autoScrollSpeed, 10) * 1000

    const config = {
      slidesPerView: 1,
      pagination: { el: this.querySelector('.swiper-pagination') },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      autoplay: autoScroll ? {
        delay: autoScrollSpeed,
        disableOnInteraction: false,
      } : false,
    }

    let swiper = new Swiper(this.querySelector('.swiper-container'), config)

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        swiper = new Swiper(this.querySelector('.swiper-container'), config)
      })

      document.addEventListener('shopify:section:unload', () => { swiper.destroy() })

      document.addEventListener('shopify:block:select', (evt) => {
        if (!this.contains(evt.target)) return
        const index = Array.prototype.indexOf.call(evt.target.parentNode.children, evt.target)
        swiper.slideTo(index)
      })
    }
  }
})
